<template>
  <v-menu
    v-model="menuRef"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :nudge-right="40"
    min-width="290px"
    :disabled="readonly || disabled"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormattedValue"
        :label="label"
        prepend-inner-icon="event"
        v-on="on"
        readonly
        :disabled="disabled"
        :rules="[requiredCheck()]"
        :clearable="clearable ? clearable : false"
        @click:prepend="menuRef = true"
        outlined
        :dense="dense ? dense : false"
        :hide-details="hideDetails ? hideDetails : false"
      ></v-text-field>
    </template>
    <v-date-picker
      :readonly="readonly"
      :disabled="disabled"
      :class="{'week-highlight': useWeekSelection}"
      v-model="dateSelectedValue"
      @input="menuRef = false"
      :type="type"
      :min="minDateValue"
      :max="maxDateValue"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { required } from '@/lib/formValidations'
import { toDateOnlyString, formatDate } from '@/lib/display'

export default {
  props: [
    'value',
    'label',
    'isRequired',
    'useWeekSelection',
    'type',
    'disabled',
    'minDate',
    'minDateEnable',
    'maxDate',
    'maxDateEnable',
    'clearable',
    'readonly',
    'dense',
    'hideDetails'
  ],
  data () {
    return {
      menuRef: false
    }
  },
  computed: {
    minDateValue () {
      if (this.minDateEnable) {
        if (this.minDate) {
          return this.minDate
        }
        return new Date().toISOString()
      }
      return undefined
    },
    maxDateValue () {
      if (this.maxDateEnable) {
        if (this.maxDate) {
          return this.maxDate
        }
        if (this.dateFormattedValue && new Date(this.dateFormattedValue) > new Date()) {
          return new Date(this.dateFormattedValue).toISOString()
        }
      }
      return undefined
    },
    dateSelectedValue: {
      get () {
        return toDateOnlyString(this.value)
      },
      set (newValue) {
        this.$emit('selected-date-change', newValue)
      }
    },
    dateFormattedValue: {
      get () {
        if (this.value) {
          return formatDate(new Date(this.value.split('T')[0]).toISOString().substr(0, 10))
        }
        return null
      },
      set (newValue) {
        this.dateSelectedValue = newValue
      }
    }
  },
  methods: {
    requiredCheck () {
      return !this.isRequired || required(this.label)
    }
  }
}
</script>

<style>
.week-highlight .v-date-picker-table.v-date-picker-table--date.theme--light tbody tr:hover {
  background-color: #91baff;
}
</style>
